import firebase from "firebase";
import "firebase/firestore";
import firebaseConfig from "./firebaseConfig.js";
import store from "./../store";

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();
const fieldValue = firebase.firestore.FieldValue;
const auth = firebase.auth();
const functions = firebase.functions();
// if (location.hostname === "localhost") {
//   db.settings({
//     host: "localhost:8070",
//     ssl: false
//   });
//   firebase.functions().useFunctionsEmulator("http://localhost:5001")
// }
//When ever the user authentication state changes write the user to vuex.
firebaseApp.auth().onAuthStateChanged(user => {
  if (user) {
    store.dispatch("setUser", user);
  } else {
    store.dispatch("setUser", null);
  }
});

export { db, storage, fieldValue, auth, functions };
